import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.75);
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Modal = styled.div`
    width: 90%;
    height: 90%;;
    background: white;
    border-radius: ${rem(12)};
    position: relative;
    @media (min-width: ${breakpoints.sm}px) {
        width: ${rem(700)};
        height: auto;
    }
`;

export const ModalContent = styled.div`
    width: 100%;
    height: 100%;
   
    @media (max-width: ${breakpoints.sm}px) {
        top:0;
        left:0;
        position: absolute;
        overflow: scroll;
        scrollbar-width: none;
    }
`;

export const CloseButton = styled.div`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: ${rem(15)};
    top: ${rem(15)};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    min-height: ${rem(110)};
`;

export const Image = styled.img`
    width: ${rem(140)};
    height: ${rem(140)};
    border-radius: 50%;
    border: ${rem(8)} solid white;

    @media (min-width: ${breakpoints.sm}px) {
        position: absolute;
        left: ${rem(20)};
        top: -${rem(15)};
    }
`;

export const Name = styled.span<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    color: ${(props) => props.colors?.colorLink};
    display: block;
    padding: ${rem(20)} ${rem(20)} 0 ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-left: ${rem(175)};
    }
`;

export const Label = styled.p`
    padding: ${rem(5)} ${rem(20)};
    line-height: ${rem(20)};
    margin: 0;
    min-height: ${rem(35)};
    @media (min-width: ${breakpoints.sm}px) {
        margin-left: ${rem(175)};
    }
`;

export const LabelPosition = styled.p`
    padding: ${rem(15)} ${rem(20)} ${rem(0)} ${rem(20)};
    line-height: ${rem(20)};
    margin: 0;
    min-height: ${rem(35)};
    @media (min-width: ${breakpoints.sm}px) {
        margin-left: ${rem(175)};
    }
`;

export const Description = styled.p`
    padding: ${rem(10)} ${rem(20)} 0 ${rem(20)};
    line-height: ${rem(20)};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${rem(60)} ${rem(80)} ${rem(20)} ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const Social = styled.div`
    float: left;
`;

export const Icon = styled(IconTemplate)<{ colors: IColors }>`
    margin-right: ${rem(10)};
    cursor: pointer;

    svg {
        width: ${rem(25)};
        margin-top: ${rem(4)};

        path,
        rect,
        circle {
            fill: ${(props) => props.colors?.colorLine};
        }
    }
`;

export const Link = styled.a<{ colors: IColors }>`
    float: left;
    display: flex;
    align-items: center;
    color: ${(props) => props.colors?.colorLink};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    cursor: pointer;
    text-decoration: none;
`;
